var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-open-model"},[_c('div',{staticClass:"model-inner"},[_vm._v(" 海外航线在线值船请前往皇家加勒比APP"),_c('br'),_vm._v("或"),_c('br'),_c('a',{attrs:{"href":"https://www.royalcaribbean.com/booked"}},[_vm._v("www.royalcaribbean.com")])])])
}]

export { render, staticRenderFns }